module.exports = __webpack_public_path__ + "images/c8d44082e2e3195be72e499b1e97d96f.png";